import React from 'react';
import './ImportFile.scss';
import { useTranslation } from 'react-i18next';
import Papa, { ParseResult } from 'papaparse';
import { ImportProjectData } from '../../../models/projects/ImportProjectData';
import { importProjects } from '../../../services/projects/ProjectService';

interface ImportFileProps {
  importEndCallback: () => void;
}

const ImportFile: React.FC<ImportFileProps> = ({ importEndCallback }) => {
  const { t } = useTranslation();

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results: ParseResult<ImportProjectData>) => {
        try {
          const data = results.data as ImportProjectData[];
          importProjects(data).then((isImported) => {
            importEndCallback();
            console.log(isImported);
          });
        } catch (err) {
          console.error('Error uploading CSV:', err);
        }
      },
    });
  };

  return (
    <div>
      <input type="file" accept=".csv" onChange={handleFileUpload} />
    </div>
  );
};

export default ImportFile;
